import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoItemDescontoMaximoExcedidoTableModule } from '../desconto-maximo-excedido-table';

import { PedidoItemDescontoMaximoExcedidoTableViewComponent } from './pedido-item-desconto-maximo-excedido-table-view.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoItemDescontoMaximoExcedidoTableModule
    ],
    declarations: [
        PedidoItemDescontoMaximoExcedidoTableViewComponent
    ],
    exports: [
        PedidoItemDescontoMaximoExcedidoTableViewComponent
    ]
})
export class PedidoItemDescontoMaximoExcedidoTableViewModule { }
